export enum MessageType {
  SMS = 'sms',
  TEXT = 'text',
  STANDALONE = 'standalone',
  CAROUSEL = 'carousel'
}

export enum SuggestionType {
  REPLY = 'reply',
  OPEN_URL = 'openUrl',
  DIAL_PHONE = 'dialPhone',
  VIEW_LOCATION = 'viewLocation',
  CALENDAR_EVENT = 'calendarEvent'
}

export interface RcsMessageConfig {
  channel: string;
  from: string;
  to: Recipient[];
  callbackData?: string;
  content: RcsContent;
}

export interface Recipient {
  msisdn: string[];
  correlationId: string;
  substitutions?: {
    text?: string;
    [key: string]: any;
  };
  options?: {
    smsFallback?: boolean;
    smsSenderId?: string;
    text?: string;
    domain?: string;
  };
}

export interface RcsContent {
  type: MessageType;
  text?: string;
  richCard?: RichCard;
  width?: 'SMALL' | 'MEDIUM';
  cards?: CarouselCard[];
  suggestions?: Suggestion[];
}

export interface RichCard {
  title: string;
  description: string;
  orientation?: 'VERTICAL' | 'HORIZONTAL';
  thumbnailAlignment?: 'LEFT' | 'RIGHT';
  media?: {
    url: string;
    height: 'SHORT' | 'MEDIUM' | 'TALL';
  };
  thumbnail?: {
    url: string;
    height: 'SHORT' | 'MEDIUM' | 'TALL';
  };
  suggestions?: Suggestion[];
}

export interface CarouselCard {
  title: string;
  description: string;
  media?: {
    url: string;
    height: 'SHORT' | 'MEDIUM' | 'TALL';
  };
  thumbnail?: {
    url: string;
    height: 'SHORT' | 'MEDIUM' | 'TALL';
  };
  suggestions?: Suggestion[];
}

export interface Suggestion {
  type: SuggestionType;
  displayText: string;
  // For openUrl
  url?: string;
  // For dialPhone
  phone?: string;
  // For viewLocation
  address?: string;
  latitude?: number;
  longitude?: number;
  // For calendarEvent
  startTime?: string;
  endTime?: string;
  meetingTitle?: string;
  meetingDescription?: string;
}

// Internal model for the builder UI
export interface RcsMessage {
  id?: string;
  type: MessageType;
  text?: string;
  smsText?: string;
  richCard?: RichCard;
  carousel?: {
    width: 'SMALL' | 'MEDIUM';
    cards: CarouselCard[];
  };
  suggestions?: Suggestion[];
  timestamp?: Date;
  // Fallback SMS data
  fallbackText?: string;
  fallbackSenderId?: string;
}
